export const paymentStatusTypes = {
  PENDING: 'pending',
  FAILED: 'failed',
  COMPLETE: 'complete',
  APPROVAL_NEEDED: 'approval_needed',
  CANCELED: 'canceled'
};

export default { paymentStatusTypes };
